//
import { required } from '@/services/validations'
import BranchOfficeModel from '@/models/General/GBranchOffice'
import ProductModel from '@/models/Warehouse/WhProduct'
import ProviderModel from '@/models/Purchase/PchProvider'

//
import SelectedProviderPurchaseQuotationModel from '@/models/Purchase/PchSelectedProviderPurchaseQuotation'

//
import ProductFilters from '@/views/Warehouse/WhProduct/list/filters'
import ProductHeaders from '@/views/Warehouse/WhProduct/list/headers'

//
import ProviderFilters from '@/views/Purchase/PchProvider/list/filters'
import ProviderHeaders from '@/views/Purchase/PchProvider/list/headers'

//
import headers from './headers'

//
export default [
    {
        name: 'g_branch_office_id',
        props: {
            itemText: 'name',
            itemValue: 'id',
            noObject: true,
            label: 'Sucursal',
            model: BranchOfficeModel,
            noFilter: true,
            paramSearch: 'address',
        },
        type: 'autocomplete-model',
    },
    {
        name: 'pch_selected_products_purchase_quotations',
        type: 'data-table-model',
        flex: {
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: headers.product,
            noActions: true,
            noDataText: 'Sin productos.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            pickerProps: {
                filters: ProductFilters.slice(0, -1),
                headers: ProductHeaders,
                mapper: row => {
                    row.quantity = 1
                    return row
                },
                noPagination: false,
                submitText: 'confirmar selección',
                service: ProductModel,
                showNativePagination: false,
                title: 'Seleccionar producto(s)',
            },
            showNativePagination: true,
            showPicker: true,
            toolbarTitle: 'Lista de productos incluidos en la cotización',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
            rules: [required],
        },
    },
    {
        name: 'pch_selected_providers_purchase_quotations',
        type: 'data-table-model',
        flex: {
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: headers.provider,
            noActions: true,
            noDataText: 'Sin proveedores.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            pickerProps: {
                filters: ProviderFilters,
                headers: ProviderHeaders,
                mapper: row =>
                    new SelectedProviderPurchaseQuotationModel(row).reset(),
                submitText: 'confirmar selección',
                service: ProviderModel,
                noPagination: false,
                showNativePagination: false,
                title: 'Seleccionar proveedor(es)',
            },
            showNativePagination: true,
            showPicker: true,
            toolbarTitle: 'Lista de proveedores incluidos en la cotización',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
            rules: [required],
        },
    },
    {
        name: 'observation',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            label: 'Observación',
            rules: [required],
        },
    },
]
